export default __webpack_public_path__ + "static/media/activityHeaderBG.27e50abb.jpg";